<template>
  <v-app>
    <v-main class="background">
      <router-view/>
    </v-main>
  </v-app>
</template>

<style>
.background {
background: #00174a1a;
}
</style>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
